export const defaultFilter = () => {
    return {
        title: null,
        company_id: null,
        vid_video_category_id: null,
        page: 1,
        per_page: 10,
    }
}

export const defaultpayloadFormCategory = () => {
    return {
        title: null,
        company_id: null,
        vid_video_category_id: null,
        page: 1,
        per_page: 10,
    }
}

export const defaultFilterCategory = () => {
    return {
        title: null,
        vid_video_category_id: null,
        page: 1,
        per_page: 10,
        state: 'all',
    }
}

export default {
    filter: defaultFilter(),
    video_categories: [],
    videosByCategory: {},
    videos: { data: [], total: 0 },
    showModalForm: false,
    payloadForm: {
        id: null,
        title: null,
        description: null,
        link: null,
        vid_video_category_id: null,
        companies_ids: [],
        files: [],
        type: 'all-companies',
        new_files: [],
    },
    defaultPayloadForm: {
        id: null,
        title: null,
        description: null,
        link: null,
        vid_video_category_id: null,
        companies_ids: [],
        files: [],
        type: 'all-companies',
        new_files: [],
    },
    company_videos: { data: [], total: 0 },
    showModalFormCategory: false,
    payloadFormCategory: {
        id: null,
        title: null,
        vid_video_category_id: null,
    },
    filterCategories: defaultFilterCategory(),
    categories_list: { data: [], total: 0 },
}
